import React, { useRef, useEffect } from "react";
import classNames from "classnames";
import config from "../../config/config.json";

const GalleryImagePair = ({
  id,
  pairObject,
  beforeImagePath,
  beforeImage,
  afterImagePath,
  afterImage,
  toggleImageSelection,
  columns,
}) => {
  const beforeImgRef = useRef(null);
  const afterImgRef = useRef(null);

  // Determine API URL based on environment
  const getApiBaseUrl = () => {
    if (process.env.REACT_APP_API_URL) {
      console.log(
        `[${id}] Using REACT_APP_API_URL:`,
        process.env.REACT_APP_API_URL
      );
      return process.env.REACT_APP_API_URL;
    }

    const buildThumbnailUrl = (id) => {
      return `${getApiBaseUrl()}/images/${id}-thumb.jpg`;
    };

    const fallbackUrl = `http://${config.ip}:${config.port}`;
    return fallbackUrl;
  };

  // Create image URL builder
  const buildImageUrl = (imageName) => {
    if (!imageName) {
      console.warn(`[${id}] buildImageUrl received null or empty imageName.`);
      return `photobooth-kiosk-production.up.railway.app/images/${imageName}`;
    }
    const url = `${getApiBaseUrl()}/images/${imageName}`;
    console.log(`[${id}] Built image URL:`, url);
    return url;
  };

  const wrapperClasses = classNames(
    "image-item",
    "relative",
    "inline-flex",
    "flex-col",
    "p-1",
    "bg-black",
    "bg-opacity-20",
    {
      "w-full": columns === 1,
      "w-1/2": columns === 2,
      "w-1/4": columns === 4,
      "w-1/6": columns === 6,
      selected: pairObject.selected,
    }
  );

  // Prepare image sources
  const beforePath = pairObject["before_jpg_path"];
  const afterPath = pairObject["after_jpg_path"];
  console.log("afterImage: ", afterImage);
  console.log("beforeImage: ", beforeImage);

  const beforeImageUrl = beforePath
    ? buildImageUrl(beforeImage)
    : beforeImage
    ? `data:image/jpeg;base64,${beforeImage}`
    : "";
  console.log("beforeImageUrl: ", beforeImageUrl);
  const afterImageUrl = afterPath
    ? buildImageUrl(afterImage)
    : afterImage
    ? `data:image/jpeg;base64,${afterImage}`
    : "";
  console.log("afterImageUrl: ", afterImageUrl);
  useEffect(() => {
    console.log(`[${id}] Rendering GalleryImagePair`);
    console.log(`[${id}] beforeImageUrl:`, beforeImageUrl);
    console.log(`[${id}] afterImageUrl:`, afterImageUrl);
  }, [beforeImageUrl, afterImageUrl, id]);

  const handleImageError = (e) => {
    console.error(`[${id}] Failed to load image: ${e.target.src}`);
    e.target.src = "/placeholder.jpg";
  };

  return (
    <div
      className={wrapperClasses}
      onClick={() => toggleImageSelection(pairObject)}
    >
      <div className="inline-flex">
        <div className="image-wrapper w-1/2 inline-block bg-black bg-opacity-30">
          <img
            ref={beforeImgRef}
            width="768"
            height="512"
            src={beforeImageUrl}
            alt={`${id} Before`}
            className="lazyload"
            onError={handleImageError}
          />
        </div>
        <div className="image-wrapper w-1/2 inline-block bg-black bg-opacity-30">
          <img
            ref={afterImgRef}
            width="768"
            height="512"
            src={afterImageUrl}
            alt={`${id} After`}
            className="lazyload"
            onError={handleImageError}
          />
        </div>
      </div>
      <p className="text-center ml-auto mr-auto">{id}</p>
    </div>
  );
};

export default GalleryImagePair;
